import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', function(){
    const counters = document.querySelectorAll('.count-up');

    counters.forEach(counter => {
        // get attributes
        const countTo = counter.getAttribute('data-count-to');
        const prefix = counter.getAttribute('data-count-prefix');
        const suffix = counter.getAttribute('data-count-suffix');

        // check validity and number type
        if ( ! countTo?.length ) return;

        const isFloat = Number(countTo) % 1 !== 0;
        
        // set up counter
        new CountUp(counter, countTo, {
            enableScrollSpy: true,
            scrollSpyOnce: true,
            scrollSpyDelay: 0,
            duration: 3,
            decimalPlaces: isFloat ? 1 : 0,
            separator: '',
            useGrouping: false,
            decimal: ',',
            prefix: prefix?.length ? prefix : '',
            suffix: suffix?.length ? suffix : ''
        });
    });
});